import {faqMap} from "@/functions/faqMap";
import {user} from "@/functions/user";
import {isPreparerContext} from "@/functions/getPreparerContext";
import getBrandName from "@/functions/getBrandName";

const AUTH_HOST = /^(https?:\/\/)auth\./i

const faqService = () => {
	const faqHost = 'https://' + process.env.VUE_APP_FAQ_API_SUBDOMAIN + '.' + getBrandName() + '.com'
	const api = faqHost + process.env.VUE_APP_FAQS_API
	const apiParameter = faqHost + process.env.VUE_APP_FAQ_API
	const currentTaxYear = process.env.VUE_APP_CURRENT_TAX_YEAR
	const authSubdomain = process.env.VUE_APP_AUTH_SUBDOMAIN || 'auth'
	let isLoading = false

	const loadFaqs = async () => {
		if (isLoading) return
		isLoading = true
		try {
			let year = sessionStorage.getItem('appYear')

			if (Number(year) <= 2018) {
				year = currentTaxYear
			}

			const faqList = []
			const extraFaqList = []

			for (let faq in faqMap) {
				if (faqMap[faq][year]) {
					faqList.push(faqMap[faq][year])
				} else {
					extraFaqList.push(faqMap[faq][currentTaxYear])
				}
			}

			if (year === currentTaxYear || (faqList.length !== 0 && extraFaqList.length === 0)) {
				await fetchFaqData(faqList, year)
			} else if (faqList.length === 0 && extraFaqList.length !== 0) {
				await fetchFaqData(extraFaqList, currentTaxYear)
			} else {
				await fetchFaqData(faqList, year)
				await fetchFaqData(extraFaqList, currentTaxYear)
			}
		} finally {
			isLoading = false
		}
	}

	const fetchFaqData = async (list, year) => {
		try {
			const res = await fetch(api, {
				method: 'post',
				credentials: "include",
				headers: {
					'content-type': 'application/json'
				},
				body: JSON.stringify({
					"faq_ids": list,
					"year": year,
					"source": "Taxes Auth",
					"is_freefile": window.location.href.includes("FREEFILE") ? "Y" : "N",
					"is_not_freefile": "N",
					"app_name": user.appName,
					"visibility": [0, 2],
					"url": apiParameter
				})
			})
			if (!res.ok) {
				throw new Error('FAQ fetch failed: ' + res.status)
			}
			const data = await res.json()
			list.forEach(faqId => {
				const faq = data[faqId]
				if (!faq) return
				if (typeof faq.text === 'string' && faq.text.includes('href="')) {
					faq.text = rewriteAuthLinks(faq.text)
				}
				sessionStorage.setItem("FAQ-" + faqId, JSON.stringify(faq))
			})
			sessionStorage.setItem('faqs' + year + 'Loaded', 'true')
			refreshOpenFaqModal()
		} catch (error) {
			console.log(error)
		}
	}

	const rewriteAuthLinks = (text) => {
		let paramList
		try {
			paramList = JSON.parse(sessionStorage.getItem('urlParamString')) || []
		} catch {
			paramList = []
		}
		const sessionYear = sessionStorage.getItem('appYear') || ''
		return text.replace(/href="([^"]*)"/g, (match, url) => {
			if (!AUTH_HOST.test(url)) return match
			const authUrl = url.replace(AUTH_HOST, '$1' + authSubdomain + '.')
			let query = authUrl.includes('?') ? '&' : '?'
			paramList.forEach(param => { query += param + '&' })
			query += 'appYear=' + sessionYear
			if (isPreparerContext()) {
				query += '&redirect_uri=' + sessionStorage.getItem('redirect_uri')
			}
			return 'href="' + authUrl + query + '"'
		})
	}

	const refreshOpenFaqModal = () => {
		const openId = sessionStorage.getItem('currentFaqModalId')
		if (!openId) return
		const modalEl = document.getElementById('faq' + openId + 'Modal')
		if (modalEl && !modalEl.classList.contains('modal-backdrop-hidden')) {
			modalEl.dispatchEvent(new CustomEvent('modalShown'))
		}
	}

	return {
		loadFaqs
	}
}

export default faqService
